import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useRef } from 'react';
export const useAudioVisualization = (silenceThreshold) => {
    const barData = useRef([]);
    const animationId = useRef(null);
    const startVisualization = usePersistentCallback((analyserNode, canvas) => {
        const canvasContext = canvas.getContext('2d');
        if (!canvasContext)
            return;
        const barWidth = 3;
        const barSpacing = 4;
        const numBars = Math.floor(canvas.width / (barWidth + barSpacing));
        barData.current = new Array(numBars).fill(0);
        const draw = () => {
            const bufferLength = analyserNode.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            animationId.current = requestAnimationFrame(draw);
            analyserNode.getByteFrequencyData(dataArray);
            // Calculate average amplitude with reduced sensitivity
            let average = 0;
            for (let i = 0; i < bufferLength; i++) {
                average += dataArray[i];
            }
            average /= bufferLength;
            average = average * 0.4; // Reduce sensitivity
            // Shift existing data to the left
            barData.current.shift();
            // Add the new value to the end of barData
            barData.current.push(average);
            // Clear the canvas and redraw the bars
            canvasContext.clearRect(0, 0, canvas.width, canvas.height);
            let x = 0;
            const gradient = canvasContext.createLinearGradient(0, 0, canvas.width, 0);
            gradient.addColorStop(0, 'rgb(153, 148, 252)');
            gradient.addColorStop(1, 'rgb(133, 200, 255)');
            canvasContext.fillStyle = gradient;
            // Draw bars from left to right
            for (let i = 0; i < barData.current.length; i++) {
                let barHeight;
                let fillStyle;
                const MIN_BAR_HEIGHT = 5;
                const MAX_BAR_HEIGHT = canvas.height * 0.8;
                if (barData.current[i] < silenceThreshold) {
                    barHeight = MIN_BAR_HEIGHT;
                    fillStyle = 'rgb(208, 213, 221)';
                }
                else {
                    barHeight = Math.max(MIN_BAR_HEIGHT, Math.min(MAX_BAR_HEIGHT, (barData.current[i] / 50) * canvas.height));
                    fillStyle = gradient;
                }
                const y = (canvas.height - barHeight) / 2;
                canvasContext.fillStyle = fillStyle;
                canvasContext.fillRect(x, y, barWidth, barHeight);
                x += barWidth + barSpacing;
            }
        };
        draw();
    });
    const stopVisualization = usePersistentCallback(() => {
        if (animationId.current) {
            cancelAnimationFrame(animationId.current);
            animationId.current = null;
        }
    });
    return { startVisualization, stopVisualization };
};
